import { Instance } from "mobx-state-tree";
import { FundModelBase } from "./FundModel.base";

/* The TypeScript type of an instance of FundModel */
export type FundModelType = Instance<typeof FundModel.Type>;

/* A graphql query fragment builders for FundModel */
export { selectFromFund, fundModelPrimitives, FundModelSelector } from "./FundModel.base";

/**
 * FundModel
 */
export const FundModel = FundModelBase.props({
  selected: false,
})
  .actions((self) => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }))
  .views((self) => ({
    get is_selected() {
      return self.selected;
    },
  }));
